export * from './Blog'
export * from './Home'
export * from './Pricing'
export * from './Privacy'
export * from './Terms'
export * from './pages404'
export * from './pages404/map'
